import React from 'react';
import PageLayout from './PageLayout';
import { useTranslation } from 'react-i18next';
import AssistGlove from '../images/Assistglobe.jpg';
import Standup from '../images/Standup.jpg';

const Research = () => {
  const { t } = useTranslation();

  return (
    <PageLayout>
      <div id="research" className='research-container-inner'>
        <h2 className="page-first-heading">{t('research.title')}</h2>
        <div className='research-grid'>
          <div className='research-card'>
            <img src={AssistGlove} alt={t('research.assistGloveAlt')} />
            <h5>{t('research.assistGloveTitle')}</h5>
            <p>{t('research.assistGloveDesc1')}
              <br />{t('research.assistGloveDesc2')}
              <br />
            </p>
          </div>

          <div className='research-card'>
            <img src={Standup} alt={t('research.sitToStandAlt')} />
            <h5>{t('research.sitToStandTitle')}</h5>
            <p>{t('research.sitToStandDesc1')}
              <br />{t('research.sitToStandDesc2')}
            </p>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default Research;